<template>
  <div class="main-qa">
    <HeroSection
      :title="$c.text('pages.qa-hub.title')"
      title-class="h1"
      :subtitle="`${$c.text('pages.qa-hub.subtitle')} <a href='${$config.siteUrl}/community-guidelines/'>Community Guidelines.</a>`"
      button-title="Ask a question"
      button-link="/signup/"
      :image-url="`${$config.platform === 'fa' ? 'fa-' : ''}qa.jpg`"
      class-name="qa"
      columns="col-5"
    />
    <div class="content container">
      <div class="row">
        <div class="qa col-8 col" :class="$config.platform">
          <Qa :key="key" :page="{ ...page, metaTitle }" :type="'main'" />
        </div>
        <div v-if="$store.state.layout === 'desktop'" class="col-4 col">
          <PromoBanner v-if="showPromoBanner" :is-campaign="showPromoBanner" position="side" />
          <ABBanner
            v-else
            first="GET"
            second="World-Class"
            :title="$config.platform === 'fa' ? 'FINANCE Courses' : 'Data Science'"
            :third="$config.platform === 'fa' ? '' : 'Courses'"
            side-banner
            place="qa-hub"
          />
          <SimilarQuestions :type="'popular'" :popular-questions="popularQuestions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qa from '@itbpbg/lms-components/src/Qa/Q&A.vue';
import HeroSection from '@itbpbg/lms-components/src/components/HeroSection';
import SimilarQuestions from '@itbpbg/lms-components/src/Qa/SimilarQuestions.vue';
import ABBanner from '@itbpbg/lms-components/src/ABBanner';
import PromoBanner from '@itbpbg/lms-components/src/PromoBanner';
import { CAMPAIGNS_WITH_SIDE_BANNERS } from '@itbpbg/lms-components/src/utils/campaigns';

export default {
  components: {
    Qa,
    HeroSection,
    SimilarQuestions,
    ABBanner,
    PromoBanner,
  },
  async asyncData({ $axios, route, $config }) {
    const { questions } = await $axios.$get('/qa-hub/questions?page=1&order=popularity');
    const page = await $axios.$get(`/pages/${route.fullPath}`).catch(() => false);
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();

    return {
      popularQuestions: questions,
      key: -1,
      page,
      metaTitle: `${page.metaTitle}${+route.query.page > 1 ? ` - Page ${route.query.page}` : ''}`,
    };
  },
  computed: {
    showPromoBanner() {
      if (this.$store.state.campaign && this.$store.state.campaign.startsWith('free-') && this.$store.getters['banners/showFreeBannerToUser']) {
        return true;
      }

      if (this.$store.getters['auth/user'].activeSubscription && this.$store.state.campaign === 'cyber-monday-lifetime-2024'
        && this.$store.state.banners.active && this.$store.state.banners.active.plan === 3) {
        return false;
      }

      const isCampaign = CAMPAIGNS_WITH_SIDE_BANNERS.includes(this.$store.state.campaign);
      return isCampaign && this.$store.getters['banners/showPromoBannerToUser'];
    },
  },
  watch: {
    $route(v) {
      this.metaTitle = this.page.metaTitle;
      if (+v.query.page > 1) {
        this.metaTitle += ` – Page ${+v.query.page}`;
      }
    },
  },
  mounted() {
    this.key = 1;
  },
  created() {
    this.key = 1;
  },
};
</script>

<style lang="scss" scoped>
.main-qa {
  padding-bottom: var(--spacing-160);

  .content {
    padding-top: var(--spacing-44);

    .banners {
      margin-top: var(--spacing-sm);
    }
  }
}

@include bp($bp-mobile) {
  .banners {
    display: none;
  }
}

.fa {
  .main-qa {
    ::v-deep .hero-section-wrapper .container .row > div .btn-primary {
      max-width: 166px;
      height: 40px;
      border-radius: 3px;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      padding: 8px;
      color: var(--main-light-shade-1);
    }
  }
}

@include bp($bp-laptop) {
  .fa .main-qa ::v-deep .hero-section-wrapper .container .row > div .btn-primary {
    max-width: 225px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@include bp($bp-mobile) {
  .fa {
    .main-qa {
      ::v-deep .hero-section-wrapper .container .row > div .btn-primary {
        max-width: 327px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;

        @include bp($bp-phone) {
          margin: var(--spacing-30) auto 0;
        }
      }
    }
  }
}
</style>
